/**
 * The date the current Privacy Policy and Terms of Service take effect. Both documents state it and the update notice
 * counts from it. The sitemap runs in the SSR bundle and keeps its own copy, which a spec holds to this one.
 */
export const LEGAL_DOCUMENTS_EFFECTIVE_DATE = '2026-09-27';

// How many days after that date the site keeps announcing the update to visitors who have not dismissed it.
export const LEGAL_UPDATE_NOTICE_DAYS = 30;
